import isolde from "isolde";
(() => {
  const isoldejs = new isolde({
    // parent element
    parent: document.querySelector("#isolde"),
    // filter links
    links: document.querySelectorAll("[data-isolde-link]"),
    // active class
    active: "is-active",
    // in pixels
    margin: 16,
    // for responsive
    responsive: {
      1200: {
        columns: 3,
      },
      700: {
        columns: 2,
      },
      0: {
        columns: 1,
      },
    },
    // fade in/out duration
    fadeDuration: {
      in: 300,
      out: 0,
    },
  });
})();
